/* tslint:disable */

/**
 */
export class ViewTemperatures {
    name?: number;
    value?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-temperatures.ts